/**
* with-interactions.jsx
* @author Arnaud PEZEL - Apyx (arnaud.pezel@me.com)
* @description 
* @created Tue Apr 03 2018 07:39:29 GMT+0200 (CEST)
* @last-modified Tue Apr 03 2018 07:39:29 GMT+0200 (CEST)
*/

import Vue from 'vue';
import { Watch, Prop, Component } from 'vue-property-decorator';

@Component
export default class WithInteractionsMixin extends Vue {

	@Prop({default: () => []}) protected readonly interactions!: any[]; 

	protected map: any = null;

	@Watch('interactions')
	onInteractionsChanged() {
		if (this.map && this.interactions) {
			// make a diff
			this.map.getInteractions().getArray().forEach(inter => {
				if (this.interactions.indexOf(inter) === -1) {
					this.map.removeInteraction(inter);
				}
			});
			this.interactions.map(inter => {
				if (this.map.getInteractions().getArray().indexOf(inter) === -1) {
					this.map.addInteraction(inter);
				}
			});
		}
  }

  onAfterMountedInteractions() {
    this.onInteractionsChanged();
  }

  /* LIFECYCLE HOOKS */
	created() {
		//listen for map creation from base component
		this.$on('ready', this.onAfterMountedInteractions);
	}
  
}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7005366e/with-interactions.tsx" });